class ProductPack extends HTMLElement {
  constructor() {

    super();

    this.jeansPackSize = this.querySelector('jean-pack-size');

    this.tripackdiscount = 0;
    this.sixpackdiscount = 0;

    this.abTestV1 = false;
    this.evaluatedIntelligems = false;
    //this.intelligemsInit();



    this.variants_IDs = [];
    this.totalItems = 0;
    this.sidecart = document.querySelector("side-cart");
    this.atcBtn = document.querySelector(".multiple-add-to-cart");
    this.packSizes = document.querySelectorAll(".pack-size__wrapper input");
    this.available = true;

    this.fabric = window.theme.current_prod.fabric.toLowerCase();
    this.fit = window.theme.current_prod.fit.toLowerCase();
    this.currentProduct = window.theme.current_prod.prodInfo;

    const tags = document.querySelector('variant-radios').dataset.tags;
    if (tags.includes('Mens-tees') || tags.includes('gender_Male') || tags.includes('MensTeesCollection')) {
      this.gender = 'mens';
    } else if (tags.includes('Womens-tees') || tags.includes('WomensTeesCollection')) {
      this.gender = 'womens';
    }
    if (window.PacksCore) {
      this.packsCore = window.PacksCore;
      this.packsCore.evaluateIntelligems(()=>{
        this.updateIntelligencePrices().then(()=>{
          this.changePrice(); 
          this.classList.remove('hidden');
        }); 
      });  
    } 
  }
  changeIcon(fit) {
    if (this.gender == 'mens' && fit == 'curved') fit = 'crew';
    if (this.gender != 'mens' && fit == 'boxy') fit = 'crew';
    if (fit == 'long-sleeve') fit = 'v-neck-long-sleeve';


    if (document.querySelector('.title').innerText.includes('LONG SLEEVE')) {

      //fit = fit + '-long-sleeve';
      //console.log(fit);
    }
    const tags = document.querySelector('variant-radios').dataset.tags;

    let icons = document.getElementById('tees-icons');
    if(!icons) return;

    let iconsCurrent = [...icons.querySelectorAll(`option[fit="${fit}"][gender="${this.gender}"]`)];

    // mean while we have not curved mens



    iconsCurrent.forEach((iconCurrent) => {
      const icon = iconCurrent.value;
      const pack = iconCurrent.getAttribute('pack');
      const label = document.querySelector(`label.pack-size[for="${pack}"]`);
      //label.style.backgroundImage = `url(${icon})`;
      if (label && label.querySelector('img')) label.querySelector('img').src = icon;

      if (pack == "pack-1") {
        const unitContainer = document.querySelector('.unit-wrapper-btn');
        if (unitContainer) {
          const imgElement = unitContainer.querySelector('.unit-img img');
          if (imgElement) imgElement.src = icon;
        }
      }
    });

    // every iconCurrent is a option that has as value the icon image who must to be displayed at the label.pack-size where the fit is selected and the attr of the label [for] must be equal to the option  attribute [pack]






  }
  findFit(tags) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].includes("fit_")) {
        return tags[i].split("fit_")[1].toLowerCase();
      }
    }

    return null;
  }
  findFabric(tags) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].includes("fabric_")) {
        return tags[i].split("fabric_")[1].toLowerCase();
      }
    }
  }

  /**
   * 
   * @param {string} fit 
   * hide the fit that is not equal to the fit parameter unless the title of the product contains the fit parameter
   */
  hideFit(fit) {

    const pdpTitle = document.querySelector('.product__info-container .product__title');


    if (pdpTitle && pdpTitle.textContent.toLocaleLowerCase().includes(fit) || pdpTitle && pdpTitle.textContent.toLocaleLowerCase().includes(fit.replace('-', ' '))) {

      const fitsSelector = document.querySelector('.product-fit_picker-container');
      const fits = fitsSelector.querySelectorAll('.product-fit__choice');
      fits.forEach((fitSelector) => {

        const fitText = fitSelector.textContent.replace(' ', '').toLocaleLowerCase();
        console.log('fitText', fitText);

        if (!fitText.includes(fit)) {
          fitSelector.style.display = 'none';
        }
      });

    } else if (pdpTitle && !pdpTitle.textContent.toLocaleLowerCase().includes(fit)) {
      const fitsSelector = document.querySelector('.product-fit_picker-container');
      const fits = fitsSelector.querySelectorAll('.product-fit__choice');
      fits.forEach((fitSelector) => {
        if (fitSelector.textContent.toLocaleLowerCase().includes(fit)) {
          fitSelector.style.display = 'none';
        }
      });
    }


  }

  firstPriceIntelligemsChange(firstVariant) {

    const packs = document.querySelectorAll('.pack-size__wrapper input');
    const selectedPack = document.querySelector('.pack-size__wrapper input:checked');

    const igPrice = window.igData.price.getPriceByVariantId(firstVariant);

    packs.forEach((x) => {
      console.log('x', x);
      const packSize = x.value;
      const discount = x.getAttribute('discount');
      console.log('packSize', packSize);

      // change the convert_each span number
      const label = document.querySelector(`label.pack-size[for="pack-${packSize}"]`);




      const convertEach = label.querySelector('.div .convert_each span');
      const priceEach = Math.ceil(igPrice - (igPrice * discount / 100));

      if (convertEach) convertEach.innerHTML = priceEach;
    });
    // change the general price
    let priceItem = document.querySelector(".price");
    let priceFinal = document.querySelector(".price-final");
    let priceDiscount = document.querySelector(".price-discount");
    let priceTotal = Math.ceil(igPrice * selectedPack.value);

    let priceTotalDiscount = priceTotal - (priceTotal * (selectedPack.getAttribute('discount') / 100));
    priceFinal.innerHTML = '$' + priceTotalDiscount.toFixed(2);
    priceDiscount.innerHTML = '$' + priceTotal;

    const unit = document.querySelector('.unit-wrapper');
    // change the default prices of the containers  
    // .pack-size__list input checked its currently such as this <input class="hidden" type="radio" name="pack-size" id="pack-3" discount="15" pack_og="105" pack_price="89.25" value="3">
    // so I need to change the 3 and 6 size default price values 

    // change the default price of the 3 pack

    const packSize3 = document.querySelector('.pack-size__list input[value="3"]');
    const packSize2 = document.querySelector('.pack-size__list input[value="2"]');


    const discount3 = packSize3.getAttribute('discount');
    const discount2 = packSize2.getAttribute('discount');

    const price3 = Math.ceil(igPrice * 3);
    const price2 = Math.ceil(igPrice * 2);

    const price3Discount = price3 - (price3 * (discount3 / 100));
    const price2Discount = price2 - (price2 * (discount2 / 100));

    packSize3.setAttribute('pack_og', price3);
    packSize3.setAttribute('pack_price', price3Discount);

    packSize2.setAttribute('pack_og', price2);
    packSize2.setAttribute('pack_price', price2Discount);


    let priceItem3 = packSize3.nextElementSibling;
    let priceItem2 = packSize2.nextElementSibling;

    priceItem3 = priceItem3.querySelector(".price");
    priceItem2 = priceItem2.querySelector(".price");

    if (priceItem3) {
      let pricePack3 = price3Discount.toFixed(2);
      priceItem3.innerHTML = `$${pricePack3} <small>$${price3}</small>`;
    }

    if (priceItem2) {
      let pricePack2 = price2Discount.toFixed(2);
      priceItem2.innerHTML = `$${pricePack2} <small>$${price2}</small>`;
    }






    if (unit) {
      unit.classList.remove('hidden');
      unit.querySelector('.test-unit-price span').innerHTML = '$' + igPrice;
    }
  }

  overWriteDiscountNoDiscount = (packSize, discount, firstVariant) => {


    let packsInput = document.querySelector(`#pack-${packSize}`);
    if (packsInput) packsInput.setAttribute('discount', discount);

    let labels = document.querySelector(`label[for="pack-${packSize}"].pack-size`);
    let savingsLabel = labels.querySelector('.savings.pack_tees');
    let savingsLabel2 = labels.querySelector('.savings.convert_each ');
    //img-price pack-image-price
    let priceItemWomens = labels.querySelector(".img-price.pack-image-price");
    savingsLabel.classList.add('hidden');
    //if (savingsLabel2) savingsLabel2.querySelector('span').innerHTML = ;
    if (priceItemWomens) priceItemWomens.classList.remove('hidden');
    let priceItem = labels.querySelector(".price");
    let priceFinal = labels.querySelector(".price-final");
    let priceDiscount = labels.querySelector(".price-discount");
    // sometimes item.price return a string such as "$40.00" so we need to validate first if it is a number and if not we need to convert it to a number
    let priceTotal = item.Price * packSize;

    if (!priceTotal) {
      let price = item.Price.replace('$', '');
      price = parseFloat(price);
      priceTotal = price * packSize;
    }



    let priceTotalDiscount = priceTotal;

    priceItem.classList.add('no_discount');

    priceFinal.innerHTML = '$' + priceTotalDiscount.toFixed(2);
    priceDiscount.classList.add('hidden');
  }


  changeFitLinks(fit) {
    let iconsGeneral = document.querySelectorAll(`.pack-size.extra-links_column`);
    let iconsFit = document.querySelectorAll(`.pack-size.extra-links_column[data-fit="${fit}"]`);
    iconsGeneral.forEach((icon) => {
      icon.classList.add('hidden');
    });
    iconsFit.forEach((icon) => {
      icon.classList.remove('hidden');
    });
  }


  async updateIntelligencePrices() {
    if (window.igData && window.igData.price) {
      document.querySelectorAll(".variant__size").forEach((item) => {
        const intelligencePrice = window.igData.price.getPriceByVariantId(
          item.id
        );

        if (intelligencePrice) {
          item.setAttribute("price", intelligencePrice * 100);
        }
      });
    }
    return true;
  }
  cleanUrlOnePack() {
    // for for="pack-1"
    const onePack = document.querySelector('label[for="pack-1"].pack-size');
    // on click remove the url query params 
    onePack.addEventListener('click', () => {
      document.querySelectorAll(".get-free-shipping").forEach((item) => {
        item.classList.add("hidden");
      }
      );
      const urlParams = new URLSearchParams(window.location.search);
      const paramValue = urlParams.get('bundle');
      if (paramValue) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    });
  }
  scrollColorLabelIntoView(input) {
    if (!input) return;
    const container = input.closest('.color_container_packs');
    if (!container) return;
    const label = container.querySelector(`label[for="${input.id}"]`);
    if (label) {
      label.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }
  setColorByURL() {
    setTimeout(() => {
      this.cleanUrlOnePack();

      const urlParams = new URLSearchParams(window.location.search);
      const paramValue = urlParams.get("bundle");
      const setParam = urlParams.get("color");
      if (paramValue) {
        this.packSizes.forEach((ps) => {
          console.log(`${paramValue} - ${ps.id}`);
          if (ps.id == paramValue) {
            ps.click();
          }
        });
      }
      console.log("setparam " + setParam);
      if (setParam != null) {
        console.log("color bundle clicked");
        const colorBubble = document.querySelector(`#${setParam}`);
        if (colorBubble) {
          colorBubble.click();
          this.scrollColorLabelIntoView(colorBubble);
        }
      }
      console.log(paramValue);
    }, 300);

  }

  connectedCallback() {
    console.log(window.bundleVariants);
    let sizes = this.querySelectorAll(".size-variants__wrapper input");
    let unitSizes = document.querySelectorAll(
      'variant-radios fieldset[data-option-name="Size"] input'
    );
    let colorSets = this.querySelectorAll(".color-set__wrapper input");
    this.atcBtn.addEventListener("click", () => {
      this.multipleAddToCart();
    });
    sizes.forEach((size) => {
      size.addEventListener("click", () => {
        this.pickSize();
      });
    });
    unitSizes.forEach((size) => {
      size.addEventListener("click", () => {
        //this.querySelector(`.size-variants__wrapper input[value="${size.value}"]`).checked = true;
        //this.querySelector('.pack-size__wrapper input[value="1"]').click();
      });
    });
    colorSets.forEach((colorSet) => {
      colorSet.addEventListener("click", () => {
        this.pickSize();
      });
    });
    this.packSizes.forEach((pk) => {
      pk.addEventListener("click", () => {
        this.changePackSize();
      });
    });
    this.changePackSize();
    this.pickSize();
  }

  disconnectedCallback() { }

  static get observedAttributes() {
    return [
      /* array of attribute names to monitor for changes */
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // called when one of attributes listed above is modified
  }

  async pickSize() {
    this.querySelector(".addtocart-error").style.display = "none";
    this.available = true;
    this.totalItems = 0;
    this.variants_IDs = [];
    let colorHeader = this.querySelector(".color_picker-header p span");
    let color = document.querySelector(".color-set__wrapper input:checked");

    if (this.jeansPackSize && this.jeansPackSize.setSelectedColorSet && color) await this.jeansPackSize.setSelectedColorSet(color);
    console.log(color);
    
    // Update pack label based on color set selection
    this.updatePackLabelFromColorSet(color);
    
    let packSize = this.querySelector(".pack-size__wrapper input:checked");
    let opts = document.querySelectorAll(
      ".color-set__wrapper input:checked + label .variant__size"
    );
    let checkedOpt = document.querySelector(
      ".size-variants__wrapper input:checked"
    );
    console.info(checkedOpt);
    /*let notCheckedOpt = document.querySelectorAll('.size-variants__wrapper input');
      if(checkedOpt.disabled) {disc

      }
      notCheckedOpt.forEach((ntc, index) => {
          if(ntc.checked) {
              if(ntc.disabled) {
                  if(notCheckedOpt[index+1].disabled == false) {
                      notCheckedOpt[index+1].click();
                  }
              }
          }
      });*/


    if (packSize.value != 1 && this.abTestV1) {
      document.querySelectorAll(".get-free-shipping").forEach((item) => {
        item.classList.remove("hidden");
      }
      );
    } else {

    }


    console.log("HERE CHECKED OPT");
    console.log(checkedOpt);
    const dummyId = color.getAttribute("dummy");
    let dummyWrapper = this.querySelector("#dummyPack");
    dummyWrapper.value = dummyId;
    if (checkedOpt) {
      let itemsAdded = true;
      opts.forEach((opt) => {
        console.log("HERE OPT");
        console.log(opt);
        console.log(checkedOpt.value.toLowerCase());
        console.log(opt.getAttribute("size"));
        if (checkedOpt.value.toLowerCase() == opt.getAttribute("size")) {
          //console.log(color.value);
          //console.log(opt.getAttribute("item-qty"));
          this.variants_IDs.push(opt);

          console.log("opt: ", opt);

          this.va;
          this.totalItems =
            this.totalItems + parseInt(opt.getAttribute("item-qty"));
          if (opt.getAttribute("quantity") < 5) {
            itemsAdded = false;
            this.available = false;
          }
        }
      });
      if (color.getAttribute("grand-parent-id") != null) {
        this._grandparent_id = color.getAttribute("grand-parent-id");
        this._grand_parent_title = color.getAttribute("grand-parent-title");
      }
      colorHeader.innerHTML = "";
      if (itemsAdded) {
        console.log(this.totalItems);
        this.atcBtn.classList.remove("disabled-error");
        //this.atcBtn.classList.remove('disabled');
        this.atcBtn.innerHTML = window.theme.add_to_cart;
      } else {
        console.log("here");
        this.atcBtn.classList.add("disabled-error");
        this.atcBtn.innerHTML = window.theme.add_to_cart;
      }
      let activeColors = null;
      if (color && color.nextElementSibling) {
        activeColors =
          color.nextElementSibling.querySelectorAll(".color-set__sizes");
      }
      console.log(activeColors);
      if (activeColors) {
        activeColors.forEach((ac) => {
          if (colorHeader.innerHTML != "") {
            colorHeader.innerHTML += " / ";
          }
          colorHeader.innerHTML += ac.getAttribute("color").replace("-", " ");
        });
        this.querySelector(".size-variants__wrapper").classList.remove(
          "disabled"
        );
        this.querySelector(".msg__error").classList.add("hidden");
        this.changePrice();
      } else {
        colorHeader.innerHTML = "-";
        this.querySelector(".size-variants__wrapper").classList.add("disabled");
        this.querySelector(".msg__error").classList.remove("hidden");
        this.variants_IDs = [];
        this.atcBtn.classList.add("disabled");
        this.atcBtn.innerHTML = "sold out";
        this.changePrice();
      }
      this.outOfStock();
    } else {

      this.atcBtn.classList.remove("disabled");
      let activeColors = null;
      if (color && color.nextElementSibling) {
        activeColors =
          color.nextElementSibling.querySelectorAll(".color-set__sizes");
      }
      colorHeader.innerHTML = "";
      if (activeColors) {
        activeColors.forEach((ac) => {
          if (colorHeader.innerHTML != "") {
            colorHeader.innerHTML += " / ";
          }
          colorHeader.innerHTML += ac.getAttribute("color").replace("-", " ");
        });
        this.querySelector(".size-variants__wrapper").classList.remove(
          "disabled"
        );
        this.querySelector(".msg__error").classList.add("hidden");
        this.changePrice();
      }
      this.atcBtn.innerHTML = window.theme.add_to_cart;
      this.outOfStock();
    }
    if (this.querySelector(".size-variants__wrapper input:checked")) {
      if (
        this.querySelector(".size-variants__wrapper input:checked").disabled
      ) {
        this.atcBtn.innerHTML = "Sold out";
        this.atcBtn.classList.add("disabled");
      } else {
        this.atcBtn.innerHTML = window.theme.add_to_cart ? window.theme.add_to_cart : "Add to Cart";
        this.atcBtn.classList.remove("disabled");
      }
    }

    if (color) window.PacksCore.setUrlByColor(color.getAttribute('id'), packSize.value);
    this.createSliderImage();
    this.changePrice();
  }

  updatePackLabelFromColorSet(colorSetInput) {
    const packLabelContainer = document.querySelector('.pack-label');
    if (!packLabelContainer) return;

    if (colorSetInput && colorSetInput.hasAttribute('data-customtag')) {
      const customContent = colorSetInput.getAttribute('data-customtag');
      const customParts = customContent.split('-');
      const customText = customParts[0] || '';
      const customColor = customParts[1] || 'FFFFFF';
      const customBg = customParts[2] || '000000';
      packLabelContainer.innerHTML = `<span class="pack-label-badge" style="color: #${customColor}; background-color: #${customBg};">${customText}</span>`;
    } else {
      packLabelContainer.innerHTML = '';
    }
  }

  async multipleAddToCart(itemProps) {
    if (
      !this.atcBtn.classList.contains("disabled-error") &&
      this.querySelector(".msg__error").classList.contains("hidden")
    ) {
      this.atcBtn.classList.add("loading");
      let packSize = this.querySelector(".pack-size__wrapper input:checked");
      let dummyProps = "";
      let packDiscount = 0;
      let packPrice = 0;
      let productSize = this.querySelector(
        ".size-variants__wrapper input:checked"
      ).value;
      
      this.variants_IDs.forEach((VId) => {
        if (dummyProps != "") {
          dummyProps += " / " + VId.getAttribute("color");
        } else {
          dummyProps += VId.getAttribute("color");
        }
        //console.log('intelli price',window.igData.price.getPriceByVariantId(VId.id));
        let subtotal =
          Number(VId.getAttribute("price")) *
          parseInt(VId.getAttribute("item-qty"));

        packDiscount += subtotal;
      });
      let originalPrice = packDiscount;
      packPrice = packDiscount;
      packDiscount =
        packDiscount * parseFloat(packSize.getAttribute("discount"));
      packDiscount = packDiscount / 100;
      packPrice = packPrice - packDiscount;

      if (this.available) {

        let bundleIndex = Date.now();

        console.log(bundleIndex);
        let updates = {
          items: [],
        };
        let has_no_discount = this.abTestV1 ? true : false;

        let dummyPack = {
          id: this.querySelector("#dummyPack").value,
          quantity: 1,
          properties: {
            dummyPack: true,
            bundle_index: bundleIndex,
            innerItems: dummyProps,
            ogp: `${originalPrice} - ${packPrice}`,
            packSize: packSize.value,
            originalprice: `${originalPrice}`,
            packPrice: packPrice,
            'ig-v2-mb': this.abTestV1 ? '58cs3r32fusa' : '',
            bundle_without_discount: has_no_discount,
            prodSize: productSize,
          },
        };
        if (this._grandparent_id != null) {
          dummyPack.properties._grandparent_id = this._grandparent_id;
        }
        let totalBckpPrice = 0;
        let thisDiscount = packSize.getAttribute("discount");
        let igPlusDiscount = null;
        this.variants_IDs.forEach((variantID) => {
          
          let thisID = variantID.getAttribute("id");
          let thisQty = variantID.getAttribute("item-qty");

          const price = variantID.getAttribute("price") - (variantID.getAttribute("price") * thisDiscount / 100);
          const discountedPrice = (price % 1 !== 0) ? price.toFixed(2) : price.toFixed(0);
          const bckpPrice = Number(variantID.getAttribute("bckp-pc")) / 100;
          totalBckpPrice += bckpPrice * parseInt(thisQty);
 
          const originalItemPrice = (variantID.getAttribute("price") / 100);
          const discountedItemPrice = originalItemPrice - (originalItemPrice * thisDiscount / 100);

          
          
          let obj = { 
            id: thisID,
            quantity: parseInt(thisQty),
            properties: {
              _bundle_index: bundleIndex,
              _teepack: true,
              _discount: thisDiscount,
              _parent_id: dummyPack.id,
              _grandparent_id: this._grandparent_id,
              _parent_name: this._grand_parent_title,
              _original_price: originalPrice,
              _total_price: packPrice,
              'Original price': `${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(originalItemPrice)}`,
              'Discounted price': `${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(discountedItemPrice)}`
            },
          };
          
          
          updates.items.push(obj);
          console.log("HERE UPDATES");
          console.log(updates);
        });
        
        const totalPackPrice = (packPrice / 100).toFixed(2);
        console.log('totalBckpPrice', totalBckpPrice);
        const realTotalDiscount = (1 - (totalPackPrice / totalBckpPrice)) * 100;
        console.log('realTotalDiscount', realTotalDiscount.toFixed(2));
        if (realTotalDiscount.toFixed(2) != Number(thisDiscount).toFixed(2)) {
          igPlusDiscount = (realTotalDiscount - thisDiscount);
          igPlusDiscount = `igd${igPlusDiscount}data`;
          updates.items.forEach(item => {
            item.properties._ig_data_v = igPlusDiscount;
          });
        }
        //updates.items.push(dummyPack);
        console.log(updates);
        const properties = {
          ...fetchConfig("javascript"),
          body: JSON.stringify(updates),
        };
        try {
          const response = await fetch("/cart/add.js", properties);
          const data = await response.json();

          // get the cart data and then render on the side cart
          this.atcBtn.classList.remove("loading");
          
          if (response.ok) {
            this.sidecart.getCart();
            this.sidecart.openCart();
          } else {
            // Send GTM event for HTTP errors
            if (window.AddResponseHandler) {
              window.AddResponseHandler.handleCartAddError(updates, response, data, null, 'bundle_add');
            }
          }
        } catch (err) {
          console.error(err);
          
          // Send GTM event for network/fetch errors
          if (window.AddResponseHandler) {
            window.AddResponseHandler.handleCartAddError(updates, null, null, err, 'bundle_add');
          }
        }
      }
    } else {
      this.querySelector(".addtocart-error").style.display = "block";
    }
  }

  pickFit(fit) {
    if (fit) {
      this.changeIcon(fit);
      this.changeFitLinks(fit);
    }
    let items = document.querySelectorAll(".product-fit__choice");
    let packSize = this.querySelector(".pack-size__list input:checked");
    let wrappers = this.querySelectorAll(".color-set__wrapper");
    let colorHeader = this.querySelector(".color_picker-header p span");

    colorHeader.innerHTML = "-";
    this.querySelector(".size-variants__wrapper").classList.add("disabled");
    this.querySelector(".msg__error").classList.remove("hidden");
    //this.atcBtn.classList.add('disabled');
    if (packSize.value != 1) {
      //packSize.nextElementSibling.querySelector('.price').innerHTML = '-';
    }
    this.variants_IDs = [];
    //this.atcBtn.classList.add('disabled');
    this.atcBtn.innerHTML = window.theme.add_to_cart ? window.theme.add_to_cart : "Add to Cart";
    wrappers.forEach((wrapper) => {
      wrapper.classList.add("hidden");
    });
    wrappers.forEach((wrapper) => {
      items.forEach((item) => {
        if (item.classList.contains("fit-active")) {
          if (wrapper.getAttribute("fit") == item.getAttribute("data-fit")) {
            if (wrapper.getAttribute("pack-size") == packSize.value) {
              wrapper.classList.remove("hidden");
              wrapper.querySelector("input").checked = true;

              this.pickSize();
            }
          }
        }
      });
      const selectedFit = document.querySelector(".product-fit__choice.fit-active");
      console.log('selectedFit', selectedFit);
    });
    this.createSliderImage();
    this.outOfStock();
    fontResize();
    this.changePrice();
  }


  changePrice() {
    console.log("changePrice called");
    let atc = this.querySelector(".multiple-add-to-cart");
    let packSize = this.querySelector(".pack-size__wrapper input:checked");
    let packDiscount = 0;
    let unitPrice = document.querySelector(".unit__price");
    let packPrice = 0;
    let titlePrice = document.querySelector(".pack-title__price");
    let packEach = document.querySelector(`.convert_each span[data-unit="${packSize.value}"]`);
    let ogPrice = 0;
    console.log(this.variants_IDs);
    

    if (this.variants_IDs.length != 0) {

      this.variants_IDs.forEach((VId) => {
        console.log("VId", VId);
        const itemPrice = VId.getAttribute("price") / 100;
        const itemQty = VId.getAttribute("item-qty");

        let subtotal =
          Number(itemPrice) *
          parseInt(itemQty);
        packDiscount += subtotal;
      });
      ogPrice = packDiscount;
      packPrice = packDiscount;
      packDiscount =
        packDiscount * parseFloat(packSize.getAttribute("discount"));
      packDiscount = packDiscount / 100;
      packPrice = packPrice - packDiscount;
    }

    let priceItem = packSize.nextElementSibling;
    console.log('priceItem', priceItem);
    priceItem = priceItem.querySelector(".price");
    if (packSize.value != 1) {
      if (packPrice == 0) {
        //priceItem.innerHTML = `-`;
        atc.innerHTML = window.theme.add_to_cart;
      } else {
        priceItem.innerHTML = `<span class="price-final">${window.theme.cart_currency_symbol}${Shopify.formatMoneyAmmount(packPrice)}</span> <small class="price-discount">${window.theme.cart_currency_symbol}${Shopify.formatMoneyAmmount(ogPrice)}</small> </span>`;
        let eachPrice = Math.ceil(packPrice / parseInt(packSize.value));
        /* 
        
        
        */
        if (packEach) {

          packEach.innerHTML = `${window.theme.cart_currency_symbol} ${Shopify.formatMoneyAmmount(eachPrice)}`;
        }
        //atc.innerHTML = 'add to cart';
      }
      unitPrice.classList.add("hidden");
      titlePrice.classList.remove("hidden");
    } else {
      unitPrice.classList.remove("hidden");
      titlePrice.classList.add("hidden");
    }
    titlePrice.innerHTML = priceItem.innerHTML;

  }

  changePackSize() {
    let wrapper = document.querySelector(".product-pack__content");
    let unitEls = {
      vr: document.querySelector("variant-radios"),
      vrSW: document.getElementById("variant-radios-single-wrapper"),
      fcp: document.querySelector("fit-color-picker-fixed .product-color_picker"),
      pf: document.querySelector(".product-buy-buttons"),
      vrsg: document.querySelector(".variant-radios__size-guide"),
    };
    let checkedOpt = this.querySelector(".pack-size__wrapper input:checked");
    //let extraLinks = this.querySelector(".extra-links");
    console.log(checkedOpt.value);

    if (checkedOpt.value == 1) {
      //extraLinks.classList.add("hidden");
      wrapper.classList.add("hidden");
      unitEls.vr.classList.remove("hidden");
      unitEls.vrSW.classList.remove("hidden");
      unitEls.fcp.classList.remove("hidden");
      unitEls.pf.classList.remove("hidden");
      unitEls.vrsg.classList.remove("hidden");
      
      document.querySelectorAll("fit-color-picker-fixed .product-color_picker").forEach(container => {
        const colorsContainer = container.querySelector('.color_picker-colors-container');
        if (colorsContainer && colorsContainer.innerHTML.trim() !== '') {
          container.classList.remove("hidden");
        } else {
          container.classList.add("hidden");
        }
      });
      let unitChecked = document.querySelector(
        `variant-radios fieldset[data-option-name="Size"] input:checked`
      );
      if (unitChecked) {
        unitChecked.checked = false;
        unitChecked.click();
      } else {
        let packChecked = this.querySelector(
          ".size-variants__wrapper input:checked"
        );
        if (packChecked) {
          console.log(packChecked.value);
          if(this.jeansPackSize){
            const selectedWaist = this.jeansPackSize.defaultSelected.waist;
            const selectedInseam = this.jeansPackSize.defaultSelected.inseam;

            if (selectedWaist) document.querySelector(`variant-radios fieldset[data-option-name="Waist"] input[value="${selectedWaist}"]`).click();
            if (selectedInseam) document.querySelector(`variant-radios fieldset[data-option-name="Inseam"] input[value="${selectedInseam}"]`).click();
          } else {
            document
              .querySelector(
                `variant-radios fieldset[data-option-name="Size"] input[value="${packChecked.value}"]`
              )
            .click();
          }
        }
      }
      if (document.querySelector('.seasonal-colors-container') && document.querySelector('.seasonal-colors-container').innerHTML.trim() !== '') {
        document.querySelector('.seasonal-color_picker')?.classList.remove('hidden');
      }
    } else {
      let unitSize = document.querySelector(
        'variant-radios fieldset[data-option-name="Size"] input:checked'
      );
      let sizes = this.querySelectorAll(".size-variants__wrapper input");

        wrapper.classList.remove("hidden");
        unitEls.vr.classList.add("hidden");
        unitEls.vrSW.classList.add("hidden");
        unitEls.fcp.classList.add("hidden");
        unitEls.pf.classList.add("hidden");
        unitEls.vrsg.classList.add("hidden");
        
        document.querySelectorAll("fit-color-picker-fixed .product-color_picker").forEach(container => {
          container.classList.add("hidden");
        });
      if (unitSize) {
        unitSize.checked = false;
        sizes.forEach((size) => {
          if (size.value == unitSize.value) {
            size.checked = true;
          }
        });
      }
      if (this.jeansPackSize) { this.jeansPackSize.setSelectedPackAndColor(checkedOpt.value); }  
      document.querySelector('.seasonal-color_picker')?.classList.add('hidden');
      
    }
    this.pickFit();
  }

  outOfStock() {
    let pack = this.querySelector(".color-set__wrapper:not(.hidden)");
    if (pack) {
      let packItmes = pack.querySelector("input:checked");
      let sizes = this.querySelectorAll(".size-variants__wrapper input");
      let disable = false;
      packItmes =
        packItmes.nextElementSibling.querySelectorAll(".color-set__sizes");
      sizes.forEach((size) => {
        size.classList.remove("disabled");
        size.disabled = false;
        packItmes.forEach((item) => {
          let itemSizes = item.querySelectorAll(".variant__size");
          itemSizes.forEach((itemSize) => {
            if (itemSize.getAttribute("size") == size.value.toLowerCase()) {
              if (itemSize.getAttribute("quantity") < 5) {
                size.classList.add("disabled");
                size.disabled = true;
              }
            }
          });
        });
      }); /*
          if(this.querySelector('.size-variants__wrapper input:checked').disabled) {
            let endloop = false;
            sizes.forEach(size => {
              if(!size.disabled) {
                if(endloop == false) {
                  size.click();
                  endloop = true;
                }
              }
            })
          }*/
    }
  }

  createSliderImage() {
    let bundleImg = document.querySelector(
      '.product-images-container .swiper-slide[data-swiper-slide-index="0"] .img_slider'
    );
    let bundleImgDup = document.querySelector(
      '.product-images-container .swiper-slide-duplicate[data-swiper-slide-index="0"] img'
    );
    let bundleDot = document.querySelectorAll(
      ".product-images-container .swiper-pagination .swiper-pagination-bullet img"
    );
    let color = document.querySelector(
      ".color-set__wrapper:not(.hidden) input:checked"
    );
    let modalImg = document.querySelector(
      '.product-images_zoomup-container .swiper-wrapper .swiper-slide[data-swiper-slide-index="0"] img'
    );
    let modalImgDup = document.querySelector(
      '.product-images_zoomup-container .swiper-wrapper .swiper-slide-duplicate[data-swiper-slide-index="0"] img'
    );
    let packSize = this.querySelector(".pack-size__list input:checked");
    if (packSize.value != 1) {
      if (color) {
        console.log("bundle");
        bundleImg.src = color.getAttribute("img");
        bundleImgDup.src = color.getAttribute("img");
        modalImg.src = color.getAttribute("img");
        modalImgDup.src = color.getAttribute("img");
        if (window.innerWidth >= 750) {
          bundleDot[0].src = color.getAttribute("img");
        }
        let bullet = document.querySelector(
          ".swiper-pagination .swiper-pagination-bullet"
        );
        const discount = color.getAttribute("discount");
        const badgeDiscount = document.querySelector(".badge-discount");
        if (badgeDiscount) {
          badgeDiscount.innerHTML = `${discount}% off`;
          badgeDiscount.classList.remove("hidden");
        }
        bullet.click();
      }
    } else {
      console.log("original");
      bundleImg.src = bundleImg.getAttribute("original");
      bundleImgDup.src = bundleImg.getAttribute("original");
      modalImg.src = bundleImg.getAttribute("original");
      modalImgDup.src = bundleImg.getAttribute("original");
      if (window.innerWidth >= 750) {
        bundleDot[0].src = bundleImg.getAttribute("original");
      }
      const badgeDiscount = document.querySelector(".badge-discount");
      if (badgeDiscount) {
        badgeDiscount.innerHTML = ``;
        badgeDiscount.classList.add("hidden");
      }
    }
  }
}

customElements.define("product-pack", ProductPack);


